const story = (state) => {
    return state.data?.story
}

export default {
    story,
}
